import { Paragraph1 } from '@cian/ui-kit';
import * as React from 'react';
import { Link } from '../../../common/Link';
import { IBalanceProps } from '../../types';
import { PaymentStatusContainer } from '../PaymentStatus';
import { MoneySourceContainer } from '../MoneySource';
import * as styles from './BalanceMobile.css';

export const BalanceMobile = (props: IBalanceProps) => {
  const { withMoneySource, showBalance, withPay, balanceString, payUrl, handleDepositLinkClick } = props;

  return (
    <>
      <div className={styles['wrapper']}>
        {withMoneySource && <MoneySourceContainer />}

        {showBalance && (
          <div className={styles['balance_wrapper']}>
            <Paragraph1>Баланс</Paragraph1>

            {balanceString && (
              <Paragraph1 textAlign="right">
                <div className={styles['balance']}>{balanceString}</div>

                {withPay && (
                  <Link
                    data-name="FillBalance"
                    href={payUrl}
                    target="_blank"
                    rel="noreferrer"
                    onClick={handleDepositLinkClick}
                  >
                    Пополнить
                  </Link>
                )}
              </Paragraph1>
            )}
          </div>
        )}
      </div>

      <PaymentStatusContainer />
    </>
  );
};
